var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"book book-information"},[_c('ExitBuilder'),_c('BookName'),_c('Help')],1)}
var staticRenderFns = []

export { render, staticRenderFns }